import React, { Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { selectMessageModal } from '../../redux/selectors/miscellaneous';
import { doDisplayMessageModal } from '../../redux/actionCreators/miscellaneous';
import SDialog from '../SDialog/SDialog';
import Typography from '../Typography/Typography';
import useIsMobile from '../../hooks/useIsMobile';

const resetState = {
  messageModal: {
    show: false,
    type: '',
    title: '',
    description: '',
    handleClose: null,
    handleSubmit: null,
    cancelButtontext: '',
    submitButtontext: '',
  },
};

const MessageModal = () => {

  const isMobile = useIsMobile();

  const messageModalData = useSelector(selectMessageModal);
  const dispatch = useDispatch();
  const closeModal = () => {
    dispatch(doDisplayMessageModal(resetState));
  };

  return (
    <SDialog
      title={messageModalData.title || ''}
      open={messageModalData.show}
      onClose={closeModal}
      titleConfig={{
        variant: isMobile ? 'h7M' : 'h5M'
      }}
      primaryButtonConfig={messageModalData.handleSubmit ? {
        text: messageModalData.submitButtontext ? messageModalData.submitButtontext : 'Done',
        onClick: messageModalData.handleSubmit
      } : {}}
      secondaryButtonConfig={{
        text: messageModalData.cancelButtontext ? messageModalData.cancelButtontext : 'Cancel',
        onClick: messageModalData.handleClose ? messageModalData.handleClose : closeModal,
        variant: messageModalData.handleSubmit ? 'secondary' : 'primary',
        color: 'info',
        fullWidth: messageModalData.handleSubmit ? true : false
      }}
      actionsContainer={{
        justifyContent: 'end'
      }}
    >
      <Typography variant={"b2M"} style={{ margin: '1.5rem 0' }}>{messageModalData.description}</Typography>
    </SDialog>
  );
};

export default MessageModal;
